import Image from "components/Elements/Image/Image.tsx";
import React, { useState } from "react";
import Carousel from "react-simply-carousel";
import { useContent } from "contexts/contentContext/contentContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import "./JMCarousel.scss";
const list = [
  {
    image: "subscribers/Architect",
    alt: "subscribers-image-alt-see-it-in-action-demopage-1",
    link: "subscribers-architect-link",
    title: "subscribers-architect",
  },
  {
    image: "subscribers/Musician",
    alt: "subscribers-image-alt-see-it-in-action-demopage-2",
    link: "subscribers-musician-link",
    title: "subscribers-musician",
  },
  {
    image: "subscribers/Perspective",
    alt: "subscribers-image-alt-see-it-in-action-demopage-3",
    link: "subscribers-perspective-link",
    title: "subscribers-perspective",
  },
  {
    image: "subscribers/Photographer",
    alt: "subscribers-image-alt-see-it-in-action-demopage-4",
    link: "subscribers-photographer-link",
    title: "subscribers-photographer",
  },
  {
    image: "subscribers/Printhouse",
    alt: "subscribers-image-alt-see-it-in-action-demopage-5",
    link: "subscribers-printhouse-link",
    title: "subscribers-printhouse",
  },
  {
    image: "subscribers/Videographer",
    alt: "subscribers-image-alt-see-it-in-action-demopage-6",
    link: "subscribers-videographer-link",
    title: "subscribers-videographer",
  },
];
const JMCarousel = () => {
  const { getTextByKey, getDirection } = useContent();
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [itemWidth, setItemWidth] = useState(
    (window.innerWidth * 0.6) / 3 - 20
  );

  const carouselItem = (item, i) => {
    return (
      <div
        className="image-container item-carousel"
        key={i}
        style={{
          width: itemWidth + "px",
          marginInline: "30px",
          direction: getDirection(),
        }}
      >
        <div className="item-carousel-inner">
          <a
            href={getTextByKey(item.link)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="dark-background"></div>

            <div
              className={`item-title ${
                getDirection() === "rtl" ? "item-title-rtl" : ""
              }`}
            >
              <span>{getTextByKey(item.title)}</span>
            </div>
            <Image name={item.image} ext="png" alt={getTextByKey(item.alt)} />
          </a>
        </div>
      </div>
    );
  };
  return (
    <div className="subscribers-carousel-container">
      <Carousel
        infinite
        updateOnItemClick
        centerMode
        autoplay
        autoplayDelay={5000}
        innerProps={{}}
        activeSlideIndex={activeSlideIndex}
        onRequestChange={setActiveSlideIndex}
        forwardBtnProps={{
          children: (
            <div className="arrow arrow-right">
              <Icon iconClass="arrow-carousel" name="arrow-right" />
            </div>
          ),
          style: {
            width: 100,
            height: 50,
            alignSelf: "center",
          },
        }}
        backwardBtnProps={{
          children: (
            <div className="arrow arrow-left">
              <Icon iconClass="arrow-carousel" name="arrow-left" />
            </div>
          ),
          style: {
            width: 100,
            height: 50,
            alignSelf: "center",
          },
        }}
        itemsToShow={3}
        speed={800}
        responsiveProps={[
          {
            itemsToShow: 1,
            itemsToScroll: 1,
            maxWidth: 700,
          },
        ]}
      >
        {list.map((item, i) => carouselItem(item, i))}
      </Carousel>
    </div>
  );
};

export default JMCarousel;
